// extracted by mini-css-extract-plugin
export default {"base":"OverlapTickers_base__-Ac8S","ticker":"OverlapTickers_ticker__tSjOd","icon":"OverlapTickers_icon__kTWn5"};